// extracted by mini-css-extract-plugin
export var blueBackground = "PageSection-module--blue--background--d72b6";
export var breachOverflow = "PageSection-module--breach-overflow--c7272";
export var greyBackground = "PageSection-module--grey--background--6df13";
export var hideOverflow = "PageSection-module--hide-overflow--8a8c3";
export var layout = "PageSection-module--layout--f26c0";
export var lgPadding = "PageSection-module--lg--padding--5316f";
export var mdPadding = "PageSection-module--md--padding--68c75";
export var meteoric = "PageSection-module--meteoric--cc588";
export var section = "PageSection-module--section--0452e";
export var smPadding = "PageSection-module--sm--padding--3a9ed";
export var whiteBackground = "PageSection-module--white--background--7d3ad";